import { InfoCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';
import React from 'react';
import { appConfig } from '@/config/context';

export const getTips = (
  label: string | React.ReactNode,
  tips: string | React.ReactNode,
  icon?: React.ReactNode,
  placement?: TooltipPlacement,
) => <Tooltip title={tips} placement={placement}>
    {label}{icon ?? <QuestionCircleOutlined style={{ fontSize: '14px', color: '#a3a3a9', marginLeft: '5px' }} />}
  </Tooltip>;

export const infoCircleIcon = <InfoCircleOutlined style={{ fontSize: '16px', color: '#a3a3a9', marginLeft: '5px' }} />;

export const compareModeText = <div>
  对比模式，用来标识，取满足A，B条件的全量数据对比，还是取满足A，B条件的Top子集对比。<br />
  有些业务，满足条件的全量数据量大，对比计算量大，服务响应可能比较慢，极端情况下，有可能导致服务超时。建议时间范围比较大时，对比Top子集。<br />
</div>;

export const compareStatusText = <div>
  对比状态是基于A，B两组条件而言。<br />
  全量数据对比模式中，A独有的问题，标为新增问题。B独有的问题，标为已解决问题。A和B同时包含的问题，标为遗留问题。<br />
  Top数据对比模式中，参与对比的不是全量数据，而是Top子集。A Top子集独有的问题，标为新增问题。B Top子集的独有问题，标为已解决问题。A和B的Top子集同时包含的问题，标为遗留问题。
</div>;

export const compareFullDataLoadingText = <div style={{
  fontFamily: 'PingFang SC',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '16px',
}}>
  当前查询条件下，全量数据对比，数据量太大，后台响应比较慢，有可能导致服务超时。<br />建议时间范围比较大时，对比模式选择【Top数据】，只对比Top子集。
</div>;

export const compareStatusTips = getTips('对比状态', compareStatusText);

export const appVersionOperatorTips = <>
  <span style={{ color: '#0062FF' }}>范围模式</span><br />
  区间：最小版本-最大版本<br />
  <span style={{ color: '#0062FF' }}>通配符模式</span><br />
  开头匹配：搜索关键词*<br />
  结尾匹配：*搜索关键词<br />
  中间匹配：*搜索关键词*<br />
</>;

export const cpuArchText = <div>so运行时的架构，例如x86的设备上，运行armeabi的库，此时CPU构架为x86，而运行时构架为armeabi。</div>;

export const cpuArchitectureText = <div>设备的真实CPU架构，例如x86的设备上，运行armeabi的库，此时CPU构架为x86，而运行时构架为armeabi。</div>;

export const launchIdText = <div>唯一标识应用在设备中的一次运行，从进程创建到进程被杀。对于多进程的应用，指应用的主进程在设备中的一次运行。</div>;

export const processLaunchIdText = <div>唯一标识进程在设备中的一次运行，从进程创建到进程被杀。</div>;

export const attachFileNamesText = <div>搜索包含指定附件的个例，支持多选以及用户手动输入，例如用户选择tomb.zip, log.txt，
  表示搜索包含tomb.zip或者log.txt的个例。</div>;

export const uuidNamesText = <div>请参考指引，获取so文件，或者dSYM文件的uuid。<a target={'_blank'} href={appConfig.uuidDoc}>（符号表文件提取UUID指引）</a></div>;

// 字符串筛选提示
export const stringFilterTips = <span>字符串类型筛选项，支持精确搜索和模糊搜索，大多数操作符支持输入多个关键字，详细<a target={'_blank'} href={appConfig.searchDoc}>查看指引</a>。</span>;

// 版本筛选提示
export const versionFilterTips = <span>版本类型筛选项，支持精确搜索，模糊搜索，以及范围搜索，精确搜索和模糊搜索支持输入多个关键字，详细<a target={'_blank'} href={appConfig.searchDoc}>查看指引</a>。</span>;

// 字符串数组筛选提示
export const stringArrayFilterTips = <span>字符串数组类型筛选项，支持精确搜索和模糊搜索，大多数操作符支持输入多个关键字，详细<a target={'_blank'} href={appConfig.searchDoc}>查看指引</a>。</span>;

// 字符串数组筛选提示
export const asanTypeTips = <span>Native堆地址错误类型，需开启Asan内存错误检测能力。</span>;

// 数字筛选提示
export const numberFilterTips = <span>数字类型筛选项，支持精确搜索和范围搜索，精确搜索支持输入多个关键字，详细<a target={'_blank'} href={appConfig.searchDoc}>查看指引</a>。</span>;

// 枚举类型筛选提示
export const enumFilterTips = <span>枚举类型筛选项，支持输入多个关键字，详细<a target={'_blank'} href={appConfig.searchDoc}>查看指引</a>。</span>;

// 特殊类型筛选提示
export const specialFilterTips = <span>特殊类型筛选项，支持输入多个关键字，详细<a target={'_blank'} href={appConfig.searchDoc}>查看指引</a>。</span>;

export const iosExitFileTips = <span><a target={'_blank'} href={appConfig.iosExitDoc}>查看指引</a></span>;

// ios-异常退出的帮助文档
export const iosTickInfoTips = <span><a target={'_blank'} href={appConfig.iosTickInfoDoc}>查看指引</a></span>;
export const iosExitInfoTips = <span><a target={'_blank'} href={appConfig.iosExitInfoDoc}>查看指引</a></span>;
export const iosVmmapInfoTips = <span><a target={'_blank'} href={appConfig.iosVmmapInfoDoc}>查看指引</a></span>;

export const asteriskText = <>
  <div>{'精确匹配：搜索关键词'}</div>
  <div>{'包含：*搜索关键词*'}</div>
  <div>{'开头匹配：搜索关键词*'}</div>
  <div>{'结尾匹配：*搜索关键词'}</div>
</>;

export const exitRateText = <div>
  异常退出率=异常退出次数/总退出次数<br />
  总退出次数=异常退出次数+正常退出次数
</div>;

export const iosExitRateText = <div>
  异常退出率=异常退出次数/总退出次数<br />
  总退出次数=总共上报的退出次数
</div>;

export const iosNormalCountText = <div>
  正常退出情况：用户退出、<br />
  设备重启/升级、<br />
  后台被杀<br />
</div>;

export const normalCountText = <div>
  正常退出情况：REASON_EXIT_SELF、<br />
  REASON_FREEZER、REASON_OTHER、<br />
  REASON_SIGNALED、REASON_UNKNOWN、<br />
  REASON_USER_REQUESTED、REASON_USER_STOPPED<br />
  字段含义可参阅：
  <a target={'_blank'} href={appConfig.androidApplicationExitInfo}>
    https://developer.android.com/reference/android/app/ApplicationExitInfo
  </a>
</div>;

export const harmonyOSNormalCountText = <div>
  正常退出情况：<br />UNKNOWN、<br />
  NORMAL、<br />UPGRADE、<br />
  USER_REQUEST、<br />SIGNAL、<br />
  详情可参考：
  <a target={'_blank'} href={'https://developer.huawei.com/consumer/cn/doc/harmonyos-references/js-apis-app-ability-abilityconstant#lastexitreason'}>
    https://developer.huawei.com/consumer/cn/doc/harmonyos-references/js-apis-app-ability-abilityconstant#lastexitreason
  </a>
</div>;

export const asteriskTips = <>
  <div>{'支持使用*号匹配规则，大小写敏感'}</div>
  <div>{'精确匹配：搜索关键词'}</div>
  <div>{'包含：*搜索关键词*'}</div>
  <div>{'开头匹配：搜索关键词*'}</div>
  <div>{'结尾匹配：*搜索关键词'}</div>
  <a href={appConfig.searchDoc} target={'_blank'}>使用指引</a>
</>;

export const CALLER_DEPTH_TIPS = '在原聚类深度基础上增加的用于区分调用方的聚类深度。';

export const RULES_TIPS = '增加的聚类深度中需要忽略的特征行。';

export const ISSUE_SPLIT = '受限于计算性能，暂只支持至多5000条个例拆分。超过5000条个例时，取上报时间最新的个例。';

// issue版本范围
export const VERSION_SCOPE_TIPS = '筛选条件下，上报个例出现的版本范围。';

// issue个例标签
export const ISSUE_TAG_TIPS = '筛选条件下，上报个例包含的Top5标签。';

// issue个例标签
export const REPRODUCTION_RATE_TIPS = '复现率 = 发生次数 / 影响设备数';


// 内存描述
// Java 内存泄漏
export const JAVA_LEAK_TIPS = '（监控Activity、Fragment等对象的泄漏，提供泄漏引用链信息）';

// Java 内存触顶
export const JAVA_TOP_TIPS = '（监控占用内存大的Java对象，可以提供到GC Root对象的引用链信息）';

// FD 触顶
export const FD_TIPS = '（监控进程FD资源的使用，可以提供FD详情以及每个未关闭FD的分配堆栈）';

// Native 内存触顶
export const NATIVE_TIPS = '（监控malloc、remalloc、mmap等内存分配过大的问题，提供每块未释放内存的分配堆栈信息）';

// 大图分析
export const BIG_PIC_TIPS = '（监控Bitmap与View的size不一致的问题，分析和解决图片过度解码的问题）';

// 网络错误
export const NET_ERROR_TIPS = '结果码不为0，或结果码为0且HTTP状态码大于等于400。';

export const DOMINATOR_TREE_TIPS = <span>点击查看「<a target='_blank'
  href={appConfig.dominatortreeDoc}>说明</a>」</span>;


export const STATUS_CODE_TIPS = (
  <div>
    HTTP状态码：在HTTP协议中用于表示服务器对请求的处理结果的三位数字代码。每个状态码都有特定的含义，用于指示请求的成功、重定向、客户端错误或服务器错误等不同情况。
    以下是一些常见的HTTP状态码及其含义：
    <ul style={{ paddingLeft: '20px' }}>
      <li>200 OK：请求成功，服务器成功处理了请求。</li>
      <li>301 Moved Permanently：永久重定向，请求的资源已被永久移动到新的URL。</li>
      <li>400 Bad Request：客户端错误，服务器无法理解请求的语法或参数。</li>
      <li>404 Not Found：资源未找到，服务器无法找到请求的资源。</li>
      <li>500 Internal Server Error：服务器错误，服务器在处理请求时遇到了意外错误。</li>
    </ul>
  </div>

);

export const ANDROID_RESULT_CODE_TIPS = <div>
  描述HTTP连接的状态，0是默认值，表示没有异常，-1表示连接建立异常。
</div>;

export const IOS_RESULT_CODE_TIPS = <div>
  <span>详细见
    <a target='_blank'
       href={'https://developer.apple.com/documentation/foundation/1448136-nserror_codes?language=objc'}>
    NSError Codes
    </a>。</span>
</div>;

// 通过Java接口获取的TID展示为#JavaTID=xxx，如下示例，焦点在JavaTID时，展示帮助文案
export const ANDROID_NATIVE_STACK_TIPS = '通过Linux接口gettid获取，由操作系统为每个native线程分配的唯一标识符。相同线程，JavaTID和LinuxTID是不同的，也没有直接的映射关系。';

// 通过Native接口获取的TID展示为LinuxTID=xxx，如下示例，焦点在LinuxTID时，展示帮助文案
export const ANDROID_JAVA_STACK_TIPS = '通过Java接口Thread.getId()获取，由Java虚拟机为每个线程分配的唯一标识符。相同线程，JavaTID和LinuxTID是不同的，也没有直接的映射关系。';

export const DATA_LABELING_TIPS = 'Bugly平台根据规则，对崩溃数据进行标记，如黑产，系统异常等。';

// 小程序，应用版本
export const MINI_APP_VERSION_TIPS = '小程序的版本';
// 小程序，页面URL
export const MINI_FROM_TIPS = '数据采集时，所在页面的唯一标识';
// 小程序，平台、
export const MINI_PLATFORM_TIPS = 'Android,iOS,Windows,Mac';
// 小程序，系统版本、
export const MINI_OS_VERSION_TIPS = '对应平台的系统版本';
// 小程序，框架版本、
export const MINI_FRAME_VERSION_TIPS = '对应小程序的基础库的版本';
// 小程序，厂商、
export const MINI_BRAND_TIPS = '设备的厂商';
// 小程序，机型、
export const MINI_MODEL_TIPS = '设备的型号';
// 小程序，网络、
export const MINI_NET_TYPE_TIPS = '网络类型，如WiFi，4G，5G';
// 小程序，运营商、
export const MINI_ISP_TIPS = '网络运营商';
// 小程序，地域、
export const MINI_REGION_TIPS = '上报发生时，设备所在的地域，根据网络地址得到';
// 小程序，ext1、ext2、ext3
export const MINI_EXT_TIPS = '预留字段，字符串类型';

// Electron，应用版本
export const ELECTRON_APP_VERSION_TIPS = '该产品的app版本';
// Electron 页面白屏率
export const ELECTRON_PAGE_BLANK_SCREEN_RATE_TIPS = '页面对应的白屏率';
// Electron，页面URL
export const ELECTRON_FROM_TIPS = '数据采集时，所在页面的唯一标识';
// Electron，会话ID
export const ELECTRON_SESSION_ID_TIPS = '会话的唯一标识';
// Electron，会话耗时
export const ELECTRON_SESSION_TIME_COST_TIPS = '会话的耗时（从会话开始到会话结束的区间长度）';
// Electron，会话View数
export const ELECTRON_SESSION_VIEWS_TIPS = '一次会话包含的Veiw数';
// Electron，会话Error数
export const ELECTRON_SESSION_ERRORS_TIPS = '一次会话包含的Error数';
// Electron，会话Action数
export const ELECTRON_SESSION_ACTIONS_TIPS = '一次会话包含的Action数';
// Electron，会话Action数
export const ELECTRON_SESSION_RESOURCE_TIPS = '一次会话包含的Resource数';
// Electron，耗时
export const ELECTRON_TIME_COST_TIPS = '事件耗时筛选：支持按事件的执行时长进行筛选。事件包括会话(session)、页面视图(view)、资源加载(resource)、用户操作(action)、错误(error)等类型，可展开查看子事件的详细耗时信息';
// Electron，平台、
export const ELECTRON_PLATFORM_TIPS = 'Windows,Mac,Linux';
// Electron，系统版本、
export const ELECTRON_OS_VERSION_TIPS = '对应平台的系统版本';
// Electron，框架版本、
export const ELECTRON_FRAME_VERSION_TIPS = '对应Electron的基础库的版本';
// Electron，厂商、
export const ELECTRON_BRAND_TIPS = '设备的厂商';
// Electron，机型、
export const ELECTRON_MODEL_TIPS = '设备的型号';
// Electron，网络、
export const ELECTRON_NET_TYPE_TIPS = '网络类型，如WiFi，4G，5G';
// Electron，运营商、
export const ELECTRON_ISP_TIPS = '网络运营商';
// Electron，地域、
export const ELECTRON_REGION_TIPS = '上报发生时，设备所在的地域，根据网络地址得到';
// Electron，进程类型、
export const ELECTRON_PROCESS_TIPS = '上报发生的进程类型';
// Electron，ext1、ext2、ext3
export const ELECTRON_EXT_TIPS = '预留字段，字符串类型';

export const IMPORTANCE_BACKGROUND_TIPS = 'This process contains cached code that is expendable, not actively running any app components we care about.';
export const IMPORTANCE_CANT_SAVE_STATE_TIPS = 'This process is running an application that can not save its state, and thus can\'t be killed while in the background. This will be used with apps that have R.attr.cantSaveState set on their application tag';
export const IMPORTANCE_EMPTY_TIPS = 'This process is empty of any actively running code.';
export const IMPORTANCE_FOREGROUND_TIPS = 'This process is running the foreground UI; that is, it is the thing currently at the top of the screen that the user is interacting with.';
export const IMPORTANCE_FOREGROUND_SERVICE_TIPS = 'This process is running a foreground service, for example to perform music playback even while the user is not immediately in the app. This generally indicates that the process is doing something the user actively cares about.';
export const IMPORTANCE_GONE_TIPS = 'This process does not exist.';
export const IMPORTANCE_PERCEPTIBLE_TIPS = 'This process is not something the user is directly aware of, but is otherwise perceptible to them to some degree.';
export const IMPORTANCE_PERCEPTIBLE_PRE_26_TIPS = 'This process is not something the user is directly aware of, but is otherwise perceptible to them to some degree.';
export const IMPORTANCE_SERVICE_TIPS = 'This process contains services that should remain running. These are background services apps have started, not something the user is aware of, so they may be killed by the system relatively freely (though it is generally desired that they stay running as long as they want to).';
export const IMPORTANCE_TOP_SLEEPING_TIPS = 'This process is running the foreground UI, but the device is asleep so it is not visible to the user. Though the system will try hard to keep its process from being killed, in all other ways we consider it a kind of cached process, with the limitations that go along with that state: network access, running background services, etc.';
export const IMPORTANCE_TOP_SLEEPING_PRE_28_TIPS = 'This process is running the foreground UI, but the device is asleep so it is not visible to the user. Though the system will try hard to keep its process from being killed, in all other ways we consider it a kind of cached process, with the limitations that go along with that state: network access, running background services, etc.';
export const IMPORTANCE_VISIBLE_TIPS = 'This process is running something that is actively visible to the user, though not in the immediate foreground. This may be running a window that is behind the current foreground (so paused and with its state saved, not interacting with the user, but visible to them to some degree); it may also be running other services under the system\'s control that it considers important';
export const PROVIDER_IN_USE_TIPS = 'one of the application\'s content providers is being used by another process.';
export const SERVICE_IN_USE_TIPS = 'one of the application\'s content providers is being used by another process.';
export const UNKNOWN_TIPS = '未知';


export const STATE_CREATE_TIPS = '进程创建完成。';
export const STATE_FOREGROUND_TIPS = '进程处于前台。';
export const STATE_ACTIVE_TIPS = '进程获焦。';
export const STATE_BACKGROUND_TIPS = '进程处于后台。';
export const STATE_DESTROY_TIPS = '进程销毁完成。';

export const HARMONY_EXIT_REASON_UNKNOWN_TIPS = <pre>{'未知原因。'}</pre>;

export const HARMONY_EXIT_REASON_ABILITY_NOT_RESPONDING_TIPS = <pre>{'Ability未响应。'}</pre>;

export const HARMONY_EXIT_REASON_NORMAL_TIPS = <pre>{'用户主动关闭，应用程序正常退出。'}</pre>;

export const HARMONY_EXIT_REASON_CPP_CRASH_TIPS = <pre>{'Native Crash导致的应用程序退出。'}</pre>;


export const HARMONY_EXIT_REASON_JS_ERROR_TIPS = <pre>{'当应用存在JS语法错误并未被开发者捕获时，触发JS_ERROR故障，导致应用程序退出。'}</pre>;

export const HARMONY_EXIT_REASON_APP_FREEZE_TIPS = <pre>{'卡死导致的应用程序退出。'}</pre>;

export const HARMONY_EXIT_REASON_PERFORMANCE_CONTROL_TIPS = <pre>{'因系统性能问题（如设备内存不足）导致的应用程序退出。'}</pre>;

export const HARMONY_EXIT_REASON_RESOURCE_CONTROL_TIPS = <pre>{'系统资源使用不当导致的应用程序退出。'}</pre>;


export const HARMONY_EXIT_REASON_UPGRADE_TIPS = <pre>{'应用升级导致的应用程序退出。'}</pre>;

export const HARMONY_EXIT_REASON_USER_REQUEST_TIPS = <pre>{'应用程序因多任务中心请求而退出。'}</pre>;

export const HARMONY_EXIT_REASON_SIGNAL_TIPS = <pre>{'应用程序因收到系统kill指令信号而退出。'}</pre>;
